import { styled } from "styled-components";

const Header = () => <Banner />;

const Banner = styled.div`
  min-height: 64px;
  border-bottom: 1px solid grey;
`;

export default Header;
